
import numeral from "numeral"
import isBlankStr from "underscore.string/isBlank"
import {
  MinMaxSelectWithChosen,
  InputSelector as BaseInputSelector,
  DEFAULT_SELECTOR as BASE_DEFAULT_SELECTOR,
} from "components/dropdown_menu/with_chosen"

export type InputSelector = BaseInputSelector & {
  scope?: string | Element | JQuery
  main?: string | Element | JQuery
  min_select?: string | Element | JQuery
  max_select?: string | Element | JQuery
  toggle?: string | Element | JQuery
  dropdown?: string | Element | JQuery
  min_wrapper?: string | Element | JQuery
  max_wrapper?: string | Element | JQuery
}
const DEFAULT_SELECTOR = Object.assign({}, BASE_DEFAULT_SELECTOR, {
  scope:        ".cell-listing-filter-desktop",
  main:         ".cell-listing-filter__price-dropdown-container",
  min_select:   ".cell-listing-filter__minimum-price-input",
  max_select:   ".cell-listing-filter__maximum-price-input",
  toggle:       ".dropdown-with-input-toggle",
  dropdown:     ".dropdown-menu-with-input",
  max_wrapper:  ".filter-option--price-max",
  min_wrapper:  ".filter-option--price-min",
})


class PriceDropdown extends MinMaxSelectWithChosen {
  protected name: string

  constructor(selector?: InputSelector){
    const merged_selector = Object.assign({}, DEFAULT_SELECTOR, selector)
    super(merged_selector)

    this.name = "price_dropdown_blueprint"
  }

  protected onChange(e: Event): void {
    super.onChange(e)

    this.emit("val_change")
  }
  protected convertValueToLabel(): string {
    const min_value = this.$min_select.val()
    const max_value = this.$max_select.val()

    if (!isBlankStr(min_value) && !isBlankStr(max_value)){
      return `${this.convert(min_value)} - ${this.convert(max_value)}`
    }
    else if (!isBlankStr(min_value)){
      return `> ${this.convert(min_value)}`
    }
    else if ( !isBlankStr(max_value) ){
      return `< ${this.convert(max_value)}`
    }
    else{
      return this.$selected_text.data("original-text")
    }
  }
  protected onClick(): void {
    this.toggle()

    setTimeout(() => {
      // set Timeout here
      // hypothesis: As button is not a part of the chosen jquery
      // so we handle onClick event here
      // but later chosen treat this as an clickout event of chosen
      // click our btn -> clickout of chosen -> hiding
      // so we Have to use settimeout to activate the chosen afterward
      // click our btn (onclick handle)-> clickout of chosen -> hiding -> chosen:open
      //                    |------------------------------------------------^
      // we open max_select instead as We guess user are more often to choose max price selector rather then min
      this.$max_select.trigger("chosen:open")
    })
  }

  public hide(): void {
    this.reset()
    this.$el.hide()
  }

  public show(): void {
    this.$el.show()
  }

  protected convert(val: number): string {
    return `$${numeral(val).format("0[.]0a")}`
  }
}


export {
  PriceDropdown,
  DEFAULT_SELECTOR,
}
